import { render } from "./FootAbout.vue?vue&type=template&id=7dfb8cd9&scoped=true&ts=true"
import script from "./FootAbout.vue?vue&type=script&lang=ts"
export * from "./FootAbout.vue?vue&type=script&lang=ts"

import "./FootAbout.vue?vue&type=style&index=0&id=7dfb8cd9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dfb8cd9"]])

export default __exports__